/* ==========================================================================
   LAX · EUROTAFF — Motor de la ficha de producto de conversión
   Un solo fichero para las secciones lax-cvr-*. Servido desde el CDN.
   Toda la configuración llega en atributos data- del contenedor: aquí no hay
   Liquid, así que el navegador puede cachearlo entre productos.
   ========================================================================== */
(function () {
  'use strict';

  function n(v, d) { var x = parseInt(v, 10); return isNaN(x) ? (d || 0) : x; }
  function cada(lista, fn) { Array.prototype.forEach.call(lista || [], fn); }

  /* ---------- Carrito del tema (Dawn / Shrine) ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }

  function secciones() {
    var d = drawer();
    return (d && typeof d.getSectionsToRender === 'function')
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : [];
  }

  function volcar(datos) {
    var destinos = [drawer(), document.querySelector('cart-notification')];
    for (var i = 0; i < destinos.length; i++) {
      if (destinos[i] && typeof destinos[i].renderContents === 'function' && datos && datos.sections) {
        destinos[i].renderContents(datos);
        return true;
      }
    }
    return false;
  }

  function peticion(items) {
    var ruta = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    if (ruta.indexOf('.js') === -1) ruta += '.js';
    var secs = secciones();
    var cuerpo = { items: items };
    if (secs.length) { cuerpo.sections = secs.join(','); cuerpo.sections_url = window.location.pathname; }
    return fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, datos: j }; });
    });
  }

  var enVuelo = false;

  /* Añade al carrito. /cart/add.js con items[] es ATÓMICO: si falla un
     complemento no se añade nada, así que reintentamos con el principal. */
  function anadir(items, boton, alError, alTerminar) {
    if (!items || !items.length || enVuelo) return;
    enVuelo = true;
    if (alError) alError('');
    if (boton) { boton.classList.add('is-cargando'); boton.setAttribute('aria-busy', 'true'); }

    peticion(items)
      .then(function (res) {
        if (res.ok || items.length < 2) return res;
        return peticion([items[0]]).then(function (r2) {
          if (r2.ok && alError) {
            alError((res.datos && res.datos.description)
              || 'No hemos podido añadir un complemento. Hemos añadido el producto principal.');
          }
          return r2.ok ? r2 : res;
        });
      })
      .then(function (res) {
        if (!res.ok) {
          if (alError) alError((res.datos && (res.datos.description || res.datos.message))
            || 'No se ha podido añadir al carrito.');
          return;
        }
        if (!volcar(res.datos)) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cvr:carrito'));
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lax-cvr' });
        }
      })
      .catch(function () { if (alError) alError('Ha fallado la conexión. Vuelve a intentarlo.'); })
      .then(function () {
        enVuelo = false;
        if (boton) { boton.classList.remove('is-cargando'); boton.removeAttribute('aria-busy'); }
        if (alTerminar) alTerminar();
      });
  }

  /* ======================================================================
     1 · BLOQUE DE COMPRA
     ====================================================================== */
  function iniciarCompra(raiz) {
    if (raiz.dataset.cvrListo === '1') return;
    raiz.dataset.cvrListo = '1';

    var d = raiz.dataset;
    var MONEDA = d.cvrMoneda || '€0,00';
    var UMBRAL = n(d.cvrUmbral);
    var TXT_FALTA = d.cvrTxtFalta || '';
    var TXT_OK = d.cvrTxtOk || '';
    var TXT_ATC = d.cvrTxtAtc || 'Añadir al carrito';
    var PRECIO_BASE = n(d.cvrPrecioBase);
    var carrito = n(d.cvrCarrito);

    function eur(c) {
      return MONEDA.replace('0,00', (Math.round(c) / 100).toFixed(2).replace('.', ','));
    }

    var form = raiz.querySelector('form[action*="/cart/add"]');
    var inputVid = raiz.querySelector('[data-cvr-vid]');
    var btn = raiz.querySelector('[data-cvr-atc]');
    var btnLabel = raiz.querySelector('[data-cvr-atc-label]');
    var btnSep = raiz.querySelector('[data-cvr-atc-sep]');
    var btnPrecio = raiz.querySelector('[data-cvr-atc-precio]');
    var precioUnit = raiz.querySelector('[data-cvr-precio-unit]');
    var kit = raiz.querySelector('[data-cvr-kit]');
    var express = raiz.querySelector('[data-cvr-express]');
    var compraYa = raiz.querySelector('[data-cvr-comprarya]');
    var compraYaTxt = raiz.querySelector('[data-cvr-comprarya-txt]');
    var qty = raiz.querySelector('[data-cvr-qty]');
    var cajaError = raiz.querySelector('[data-cvr-error]');
    var cajaEnvio = raiz.querySelector('[data-cvr-envio]');
    var sticky = raiz.querySelector('[data-cvr-sticky]');
    var stickyPre = sticky ? sticky.querySelector('[data-cvr-sticky-precio]') : null;

    /* La barra fija cuelga de <body>: un transform en cualquier ancestro
       rompería position:fixed. */
    if (sticky && document.body) {
      /* Al recargar la seccion en el editor se apilaban barras viejas en <body>. */
      cada(document.querySelectorAll('[data-cvr-sticky]'), function (v) {
        if (v !== sticky && v.parentNode === document.body) v.parentNode.removeChild(v);
      });
      document.body.appendChild(sticky);
    }

    /* ---------- Galería ---------- */
    (function () {
      var pista = raiz.querySelector('[data-gal-pista]');
      var puntos = raiz.querySelectorAll('[data-gal-ir]');
      if (!pista || !puntos.length) return;
      cada(puntos, function (p) {
        p.addEventListener('click', function () {
          pista.scrollTo({ left: n(p.dataset.galIr) * pista.clientWidth, behavior: 'smooth' });
        });
      });
      var t;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
          cada(puntos, function (p, j) { p.classList.toggle('is-on', j === i); });
        }, 70);
      }, { passive: true });
    })();

    /* ---------- Estado ---------- */
    function cantidad() { return Math.max(1, n(qty && qty.value, 1)); }
    function nivel() { return kit ? kit.querySelector('input:checked') : null; }
    function base() {
      var n1 = kit ? kit.querySelector('input[value="1"]') : null;
      return n1 ? n(n1.dataset.precio) : PRECIO_BASE;
    }
    function items() {
      var sel = nivel(), lista = null;
      if (sel) { try { lista = JSON.parse(sel.dataset.items); } catch (e) { lista = null; } }
      if (!lista || !lista.length) lista = [{ id: n(inputVid && inputVid.value), quantity: 1 }];
      lista[0].quantity = cantidad();
      if (sel && sel.value !== '1' && sel.dataset.nombre) {
        for (var i = 0; i < lista.length; i++) lista[i].properties = { _kit: sel.dataset.nombre };
      }
      return lista;
    }

    function error(msg) {
      if (!cajaError) { if (msg) alert(msg); return; }
      cajaError.textContent = msg || '';
      cajaError.hidden = !msg;
    }

    function pintarEnvio(total) {
      if (!cajaEnvio || !UMBRAL) return;
      var suma = carrito + total;
      var relleno = cajaEnvio.querySelector('[data-cvr-envio-relleno]');
      var texto = cajaEnvio.querySelector('[data-cvr-envio-txt]');
      if (relleno) relleno.style.width = Math.min(100, Math.round(suma / UMBRAL * 100)) + '%';
      if (texto) {
        texto.innerHTML = (suma >= UMBRAL) ? TXT_OK
          : TXT_FALTA.replace('[importe]', '<b>' + eur(UMBRAL - suma) + '</b>');
      }
      cajaEnvio.hidden = false;
    }

    function pintar() {
      var sel = nivel(), b = base();
      var total = (sel ? (n(sel.dataset.precio) || b) : b) + (cantidad() - 1) * b;
      if (btnPrecio) btnPrecio.textContent = eur(total);
      if (stickyPre) stickyPre.textContent = eur(total);
      pintarEnvio(total);
      if (kit) cada(kit.querySelectorAll('.cvr-kit__op'), function (l) {
        l.classList.toggle('is-sel', !!l.querySelector('input:checked'));
      });
      /* Los complementos viven en otra seccion (otro ambito Liquid), asi que
         les decimos por evento que hay ya dentro del kit para que no lo vendan
         dos veces. window.cvrKitIds cubre el caso de que ellos arranquen antes. */
      var lista = items();
      var idsKit = lista.map(function (x) { return x.id; });
      window.cvrKitIds = idsKit;
      document.dispatchEvent(new CustomEvent('cvr:kit', { detail: { ids: idsKit } }));

      /* El boton express nativo solo compra un articulo. Para los packs se cambia
         por un carrito permanente con todo dentro, que lleva directo al pago. */
      var multiple = lista.length > 1;
      if (express) express.style.display = multiple ? 'none' : '';
      if (compraYa) {
        compraYa.hidden = !multiple;
        if (multiple) {
          compraYa.setAttribute('href', '/cart/' + lista.map(function (x) {
            return x.id + ':' + (x.quantity || 1);
          }).join(','));
          if (compraYaTxt) compraYaTxt.textContent = 'Comprar ahora · ' + eur(total);
        }
      }
    }

    function refrescarCarrito() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { carrito = c.total_price; pintar(); })
        .catch(function () {});
    }

    /* ---------- Variantes ---------- */
    var variantes = null;
    var nodoVar = raiz.querySelector('[data-cvr-variantes]');
    if (nodoVar) { try { variantes = JSON.parse(nodoVar.textContent); } catch (e) { variantes = null; } }

    function refrescarVariante() {
      cada(raiz.querySelectorAll('.cvr-pill'), function (l) {
        l.classList.toggle('is-on', !!l.querySelector('input:checked'));
      });
      if (!variantes) return;
      var elegidas = [];
      cada(raiz.querySelectorAll('[data-cvr-opt]'), function (r) {
        if (r.checked) elegidas[n(r.dataset.cvrOpt) - 1] = r.value;
      });
      var enc = null;
      for (var i = 0; i < variantes.length && !enc; i++) {
        var ok = true;
        for (var j = 0; j < variantes[i].opciones.length; j++) {
          if (elegidas[j] && variantes[i].opciones[j] !== elegidas[j]) { ok = false; break; }
        }
        if (ok) enc = variantes[i];
      }
      if (!enc) return;
      if (inputVid) inputVid.value = enc.id;
      /* La URL tiene que llevar la variante: si algo recarga la pagina (el modal
         de upsell heredado lo hace) el cliente debe volver a SU medida. */
      if (window.history && history.replaceState && enc.id) {
        try {
          var u = new URL(window.location.href);
          if (u.searchParams.get('variant') !== String(enc.id)) {
            u.searchParams.set('variant', enc.id);
            history.replaceState({}, '', u.toString());
          }
        } catch (e) {}
      }
      if (precioUnit) precioUnit.textContent = eur(enc.precio);
      var n1 = kit ? kit.querySelector('input[value="1"]') : null;
      if (n1) {
        n1.dataset.precio = enc.precio;
        n1.dataset.items = JSON.stringify([{ id: enc.id, quantity: 1 }]);
        var etq = raiz.querySelector('[data-cvr-kit-precio1]');
        if (etq) etq.textContent = eur(enc.precio);
      }
      if (btn) {
        btn.disabled = !enc.disponible;
        if (btnLabel) btnLabel.textContent = enc.disponible ? TXT_ATC : 'Agotado';
        if (btnSep) btnSep.hidden = !enc.disponible;
        if (btnPrecio) btnPrecio.hidden = !enc.disponible;
      }
    }

    cada(raiz.querySelectorAll('[data-cvr-opt]'), function (r) {
      r.addEventListener('change', function () { refrescarVariante(); pintar(); });
    });
    if (kit) kit.addEventListener('change', pintar);
    cada(raiz.querySelectorAll('[data-cvr-cant]'), function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, n(qty.value, 1) + n(b.dataset.cvrCant));
        pintar();
      });
    });
    if (qty && qty.tagName === 'INPUT' && qty.type === 'number') qty.addEventListener('change', pintar);

    function anadirAqui(lista, boton, alError) {
      anadir(lista, boton || btn, alError || error, refrescarCarrito);
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); anadirAqui(items()); });

    if (sticky && btn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -60px 0px' }).observe(btn);
      var sBtn = sticky.querySelector('[data-cvr-sticky-btn]');
      if (sBtn) sBtn.addEventListener('click', function () { anadirAqui(items(), sBtn); });
    }

    /* Puente para la sección de complementos */
    window.cvrAnadir = anadirAqui;
    document.addEventListener('cvr:carrito', refrescarCarrito);

    refrescarVariante();
    pintar();
  }

  /* ======================================================================
     2 · COMPLEMENTOS
     ====================================================================== */
  function iniciarComplementos(raiz) {
    if (raiz.dataset.cvrListo === '1') return;
    raiz.dataset.cvrListo = '1';

    var MONEDA = raiz.dataset.cvrMoneda || '€0,00';
    var TXT_BTN = raiz.dataset.cvrTxtBoton || 'Añadir al carrito';
    function eur(c) { return MONEDA.replace('0,00', (Math.round(c) / 100).toFixed(2).replace('.', ',')); }

    var TXT_EN_KIT = raiz.dataset.cvrTxtEnKit || 'Ya incluido en tu kit';
    var casillas = raiz.querySelectorAll('[data-cvr-comp]');
    var btn = raiz.querySelector('[data-cvr-comp-btn]');
    var total = raiz.querySelector('[data-cvr-comp-total]');
    var caja = raiz.querySelector('[data-cvr-comp-error]');

    function error(msg) {
      if (!caja) { if (msg) alert(msg); return; }
      caja.textContent = msg || '';
      caja.hidden = !msg;
    }

    function elegidas() {
      var out = [];
      cada(casillas, function (c) {
        if (c.checked) out.push({ id: n(c.value), quantity: 1, precio: n(c.dataset.precio) });
      });
      return out;
    }

    function pintar() {
      var sel = elegidas();
      var suma = sel.reduce(function (a, x) { return a + x.precio; }, 0);
      if (btn) {
        btn.disabled = sel.length === 0;
        btn.textContent = sel.length ? TXT_BTN + ' · ' + eur(suma) : TXT_BTN;
      }
      if (total) total.innerHTML = sel.length > 1 ? '<b>' + sel.length + '</b> seleccionados' : '';
      cada(raiz.querySelectorAll('.cvr-comp__it'), function (l) {
        l.classList.toggle('is-sel', !!l.querySelector('input:checked'));
      });
    }

    /* Un complemento que ya viene dentro del nivel de kit elegido se desmarca y
       se bloquea: si no, el cliente paga dos geles y nadie se lo advierte. */
    function marcarEnKit(ids) {
      cada(casillas, function (c) {
        var dentro = ids.indexOf(n(c.value)) !== -1;
        var fila = c.parentElement;
        if (dentro === !!c.disabled) return;
        c.disabled = dentro;
        if (dentro) c.checked = false;
        if (fila) {
          fila.classList.toggle('is-en-kit', dentro);
          fila.style.opacity = dentro ? '.5' : '';
          fila.style.cursor = dentro ? 'default' : '';
          var etq = fila.querySelector('.cvr-comp__esencial');
          if (etq) {
            if (!etq.dataset.cvrTxt) etq.dataset.cvrTxt = etq.textContent;
            etq.textContent = dentro ? TXT_EN_KIT : etq.dataset.cvrTxt;
          }
        }
      });
      pintar();
    }
    document.addEventListener('cvr:kit', function (e) {
      marcarEnKit((e.detail && e.detail.ids) || []);
    });

    cada(casillas, function (c) { c.addEventListener('change', pintar); });

    if (btn) btn.addEventListener('click', function () {
      var sel = elegidas();
      if (!sel.length) return;
      var lista = sel.map(function (x) {
        return { id: x.id, quantity: 1, properties: { _origen: 'complementos' } };
      });
      if (typeof window.cvrAnadir === 'function') { window.cvrAnadir(lista, btn, error); return; }
      anadir(lista, btn, error);
    });

    pintar();
    if (window.cvrKitIds) marcarEnKit(window.cvrKitIds);
  }

  /* ---------- Convivencia con las secciones heredadas del tema ----------
     layout/theme.liquid inyecta lax-pdp-limpieza y lax-tal-vez-te-interesa en
     TODAS las plantillas de producto, tambien en esta, y no se pueden desactivar
     sin editar el tema. Asi que esta plantilla se defiende sola:

     1. lax-pdp-limpieza deja un formulario de pago express huerfano
        (#lax-express-pay). Su montador busca .product-form__buttons, que aqui no
        existe, asi que el form se queda fuera de pantalla pero vivo, cargando un
        segundo <shopify-accelerated-checkout>. Lo retiramos: el nuestro ya esta
        dentro de la caja de compra.
     2. lax-tal-vez-te-interesa se auto-coloca justo detras de la primera seccion
        de #MainContent, o sea entre la caja de compra y los complementos, donde
        compite con nuestro cross-sell. Lo bajamos al final: quien llega hasta
        abajo sin comprar es justo quien necesita otra medida.

     Su recolocacion corre una sola vez (marca data-lax-movido), de modo que no
     se vuelve a mover despues de esto. Todo aqui es idempotente. */
  function convivir() {
    colocarWhatsapp();
    var exp = document.getElementById('lax-express-pay');
    if (exp && exp.dataset.laxPuesto !== '1' && exp.parentNode) {
      exp.parentNode.removeChild(exp);
    }

    var tvi = document.querySelector('[id^="shopify-section-lax-tal-vez"]');
    if (!tvi || tvi.dataset.cvrBajado === '1') return;

    /* Va JUSTO ENCIMA de las resenas: quien no ha comprado arriba todavia puede
       necesitar otra medida, y las resenas cierran la pagina. Si no hubiera
       seccion de resenas, se queda al final de lo nuestro. */
    var res = document.getElementById('cvr-resenas');
    var wrapRes = res && res.closest('[id^="shopify-section"]');
    if (wrapRes && wrapRes !== tvi) {
      tvi.dataset.cvrBajado = '1';
      wrapRes.insertAdjacentElement('beforebegin', tvi);
      return;
    }
    var mias = document.querySelectorAll('.lax-cvr:not(.cvr-sticky)');
    if (!mias.length) return;
    var ultima = mias[mias.length - 1].closest('[id^="shopify-section"]');
    if (!ultima || ultima === tvi) return;
    tvi.dataset.cvrBajado = '1';
    ultima.insertAdjacentElement('afterend', tvi);
  }

  /* lax-pdp-limpieza sube el boton de WhatsApp 104/124px para dejar sitio a la
     barra fija del tema V3. Aqui esa barra no existe: la nuestra mide otra cosa
     y en escritorio ni se pinta, asi que el boton quedaba flotando en el aire.
     Estilo inline porque el heredado va con !important. */
  function colocarWhatsapp() {
    var w = document.querySelector('.rq-whatsapp-chat-container');
    if (!w) return;
    var barra = document.querySelector('[data-cvr-sticky]');
    var hueco = 16;
    if (barra && window.getComputedStyle(barra).display !== 'none') {
      hueco = Math.round(barra.getBoundingClientRect().height) + 12;
    }
    w.style.setProperty('bottom', hueco + 'px', 'important');
  }
  window.addEventListener('resize', colocarWhatsapp);

  /* ---------- Arranque ---------- */
  function iniciar(ambito) {
    var raiz = ambito || document;
    cada(raiz.querySelectorAll('[data-cvr-comprar]'), iniciarCompra);
    cada(raiz.querySelectorAll('[data-cvr-complementos]'), iniciarComplementos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); convivir(); });
  } else {
    iniciar();
    convivir();
  }
  /* Por si el script heredado se parsea despues que este */
  window.addEventListener('load', convivir);
  /* El editor de temas recarga secciones sueltas */
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
